module.exports = __webpack_public_path__ + "img/menu4.0805ab3d.svg";